import { find, get, isString, reduce } from 'lodash-es';
import { formatAmountCurrency, formatPercent } from '../../Utils/utils';

export const CSS_UID = 'calculated-6a3e28a7-5442-4ac7-a2b9-cb11d968b6c5';

/**
 * Calculate field
 * @param {Object} param
 * @param {number} param.value Value to modify
 * @param {Object} param.operations Operations
 * @param {string} param.operations.operator Operator for the calculation
 * @param {number} param.operations.constant Constant with which value will be modified
 * @param {string} param.operations.constantCode Code to get constant from
 */
export const calculateField = ({ value, operations }) => {
  try {
    if (operations && operations.length && value != null) {
      return reduce(
        operations,
        (acc, operation) => {
          let constantValue = operation.constant;

          if (operation.constantCode) {
            constantValue = get(find(operation.values, { code: operation.constantCode }), 'value', 0);
          }

          switch (operation.operator) {
            case '+':
              return parseFloat(acc) + constantValue;
            case '-':
              return parseFloat(acc) - constantValue;
            case '*':
              return parseFloat(acc) * constantValue;
            case '/':
              if (constantValue !== 0) {
                return Math.round((parseFloat(acc) / constantValue) * 100) / 100;
              }

              return acc;
            default:
              return acc;
          }
        },
        value
      );
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`calculateField: ${e.stack}`);
  }

  return value;
};

/**
 * Get label with value
 * @param {number} value
 * @param {Object} format
 * @param {string} format.type Format type (currency, percent, template)
 * @param {string | string[]} format.locales Locale(s)
 * @param {string} format.currency Currency to display
 * @param {string} format.data String template with $value to be replaced
 * @returns
 */
export const getLabelValue = (value, format) => {
  switch (format.type) {
    case 'currency':
      return formatAmountCurrency(value, format.locales, format.currency);
    case 'percent':
      return formatPercent(value, format.locales, format.currency);
    case 'template':
      if (isString(format.data)) {
        return format.data.replace(/\$value/g, value);
      }
      break;
    default:
      break;
  }

  return value;
};
